<template>
	<div class="social-sharing">
		<a
			v-for="(item, index) in socials"
			:key="index"
			:href="item.link"
			:aria-label="item.aria"
			target="_blank"
		>
			<i :class="item.iconClass" />
		</a>
	</div>
</template>

<script>
import { getProductionHost } from "@/common/functions/networkUtils";
export default {
	name: "Social",
	props: {
		articleTitle: {
			type: String,
			default: "",
		},
		articleImage: {
			type: String,
			default: "",
		},
	},
	computed: {
		articleURL() {
			return `https://${getProductionHost()}${this.$route.fullPath}`;
		},
		socials() {
			return [
				{
					link: `https://www.facebook.com/sharer/sharer.php?display=page&u=${
						this.articleURL
					}&quote=${encodeURIComponent(
						this.articleTitle
					)} via WordFinder by YourDictionary`,
					iconClass: "wficon-facebook-filled",
					title: "Share on Facebook",
					aria: "Facebook",
				},
				{
					link: `https://twitter.com/share?text=${encodeURIComponent(
						this.articleTitle
					)}&via=YourDictionary&url=${this.articleURL}`,
					iconClass: "wficon-twitter-filled",
					title: "Share on Twitter",
					aria: "Twitter",
				},
				{
					link: `http://www.pinterest.com/pin/create/bookmarklet/?url=${
						this.articleURL
					}&media=${
						this.articleImage
					}&description=${encodeURIComponent(
						this.articleTitle
					)} via WordFinder by @yourdictionary`,
					iconClass: "wficon-pinterest-filled",
					title: "Share on Pinterest",
					aria: "Pinterest",
				},
				{
					link: `mailto:?subject=${encodeURIComponent(
						this.articleTitle
					)}&body=${this.articleURL}`,
					iconClass: "wficon-mail-filled",
					title: "Send via mail",
					aria: "Mail",
				},
			];
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/media-queries";
.social-sharing {
	column-gap: 24px;
	display: flex;
	flex-direction: row;
	font-size: 38px;
	height: 38px;
	padding: 20px 0;

	@include from-medium-device {
		column-gap: 12px;
		padding: 24px 0;
	}
}
.social-sharing i {
	color: rgba(0, 0, 0, 0.87);
}
.social-sharing.bottom {
	border-top: 1px solid #b0bec5;
	padding: 24px 0;
}
</style>
